export default {
  canvas: {
    background: null,
    color: {
      hex: '#000000',
    },
    drawingMode: false,
    lineWidth: 1,
    export: '',
    image: '',
    wavy: false,
    dashed: false,
    opacity: 0.3,
  },
  activeObject: null,
  canvasObjects: null,
  exercises: [],
  exerciseLoading: false,
  categories: [],
  filters: {
    title: '',
    objectiveIds: [],
    toApproveFilter: 0,
    coachId: null,
    globalCoachId: null,
    tagIds: [],
    categoryIds: [],
    hasVideo: 0,
    linkVideo: '',
    difficulties: [],
    playersNumber: [0,50],
    exerciseMinutes: [0,120]
  },
  coachFilters: {
    title: '',
    objectiveIds: [],
    categoryIds: [],
  },
  paginationCoach: {
    page: 1,
    rowsPerPage: 24,
  },
  filtersCoach: {
    title: '',
    objectiveIds: [],
    toApproveFilter: 0,
    companyCoachId: null,
    globalCoachId: null,
    order: null,
    tagIds: [],
    categoryIds: [],
    hasVideo: 0,
    linkVideo: '',
    difficulties: [],
    playersNumber: [0,50],
    exerciseMinutes: [0,120]
  },
  paginationMyExercises: {
    page: 1,
    rowsPerPage: 24,
  },
  filtersMyExercises: {
    title: '',
    objectiveIds: [],
    toApproveFilter: 0,
    companyCoachId: null,
    globalCoachId: null,
    order: null,
    tagIds: [],
    categoryIds: [],
    hasVideo: 0,
    linkVideo: '',
    difficulties: [],
    playersNumber: [0,50],
    exerciseMinutes: [0,120]
  },
  paginationPublicExercises: {
    page: 1,
    rowsPerPage: 24,
  },
  filtersPublicExercises: {
    title: '',
    objectiveIds: [],
    toApproveFilter: 0,
    companyCoachId: null,
    globalCoachId: null,
    order: null,
    tagIds: [],
    categoryIds: [],
    hasVideo: 0,
    linkVideo: '',
    difficulties: [],
    playersNumber: [0,50],
    exerciseMinutes: [0,120]
  },
  paginationCompanyExercises: {
    page: 1,
    rowsPerPage: 24,
  },
  filtersCompanyExercises: {
    title: '',
    objectiveIds: [],
    toApproveFilter: 0,
    companyCoachId: null,
    globalCoachId: null,
    order: null,
    tagIds: [],
    categoryIds: [],
    hasVideo: 0,
    linkVideo: '',
    difficulties: [],
    playersNumber: [0,50],
    exerciseMinutes: [0,120]
  },
  paginationExercisesToApprove: {
    page: 1,
    rowsPerPage: 24,
  },
  filtersExercisesToApprove: {
    title: '',
    objectiveIds: [],
    toApproveFilter: 0,
    companyCoachId: null,
    globalCoachId: null,
    order: null,
    tagIds: [],
    categoryIds: [],
    hasVideo: 0,
    linkVideo: '',
    difficulties: [],
    playersNumber: [0,50],
    exerciseMinutes: [0,120]
  },
  paginationMyKicks: {
    page: 1,
    rowsPerPage: 24,
  },
  filtersMyKicks: {
    title: '',
    objectiveIds: [],
    toApproveFilter: 0,
    companyCoachId: null,
    globalCoachId: null,
    order: null,
    tagIds: [],
    categoryIds: [],
    hasVideo: 0,
    linkVideo: '',
    difficulties: [],
    playersNumber: [0,50],
    exerciseMinutes: [0,120]
  },
  paginationKicks: {
    page: 1,
    rowsPerPage: 24,
  },
  filtersKicks: {
    title: '',
    objectiveIds: [],
    toApproveFilter: 0,
    companyCoachId: null,
    globalCoachId: null,
    order: null,
    tagIds: [],
    categoryIds: [],
    hasVideo: 0,
    linkVideo: '',
    difficulties: [],
    playersNumber: [0,50],
    exerciseMinutes: [0,120]
  },
  paginationCompanyKicks: {
    page: 1,
    rowsPerPage: 24,
  },
  filtersCompanyKicks: {
    title: '',
    objectiveIds: [],
    toApproveFilter: 0,
    companyCoachId: null,
    globalCoachId: null,
    order: null,
    tagIds: [],
    categoryIds: [],
    hasVideo: 0,
    linkVideo: '',
    difficulties: [],
    playersNumber: [0,50],
    exerciseMinutes: [0,120]
  },
  paginationKicksToApprove: {
    page: 1,
    rowsPerPage: 24,
  },
  filtersKicksToApprove: {
    title: '',
    objectiveIds: [],
    toApproveFilter: 0,
    companyCoachId: null,
    globalCoachId: null,
    order: null,
    tagIds: [],
    categoryIds: [],
    hasVideo: 0,
    linkVideo: '',
    difficulties: [],
    playersNumber: [0,50],
    exerciseMinutes: [0,120]
  },
  topTags: [],
};



// WEBPACK FOOTER //
// ./src/store/exercises/state.js